import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "11",
  fill: "none",
  viewBox: "0 0 14 11"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#464441",
  d: "M11.228 0 4.491 6.568 2.246 4.38 0 6.569l4.491 4.378 8.983-8.758z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }